export default __webpack_public_path__ + "static/media/language_icon.4e3fbc49.png";